import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CUADRO_DE_MANDO } from '../../../config/forms'
import * as actions from '../actions'
import CuadroDeMandoComp from '../components/CuadroDeMandoComp'

const FormCuadroDeMando = () => {
  return (
    <>
      <h3 style={{ marginTop: '-3%' }}>Cuadro de mando de descarga</h3>
      <CuadroDeMandoComp />
    </>
  )
}

const withRedux = connect(null, actions)
export default withRedux(reduxForm({ form: FORM_CUADRO_DE_MANDO })(FormCuadroDeMando))
